// src/components/gamification/BadgeCard.tsx
import React from 'react';
import { Card, CardContent, Typography, Box, Tooltip } from '@mui/material';
import { Badge } from '../../services/interfaces';

interface BadgeCardProps {
    badge: Badge;
}

export const BadgeCard: React.FC<BadgeCardProps> = ({ badge }) => {
    const getBadgeColor = (level: Badge['level']) => {
        const colors = {
            bronze: '#CD7F32',
            silver: '#C0C0C0',
            gold: '#FFD700',
            platinum: '#E5E4E2'
        };
        return colors[level];
    };

    return (
        <Tooltip title={`${badge.description}${badge.earnedDate ? `\nдобијена: ${new Date(badge.earnedDate).toLocaleDateString()}` : ''}`}>
            <Card sx={{
                width: 120,
                height: 120,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                opacity: badge.earnedDate ? 1 : 0.5,
                border: 2,
                borderColor: getBadgeColor(badge.level)
            }}>
                <CardContent>
                    <Box
                        component="img"
                        src={badge.imageUrl}
                        alt={badge.name}
                        sx={{ width: 48, height: 48, mb: 1 }}
                    />
                    <div>
                        <Typography variant="caption" align="center">
                            {badge.name}
                        </Typography>
                    </div>
                </CardContent>
            </Card>
        </Tooltip>
    );
};